import React from "react";

interface Props {
  showTakeSeatText?: boolean;
}

const GaitCalibrationComplete: React.FC<Props> = ({ showTakeSeatText = false }) => {
  return (
    <>
      <div className="person-detected-modal text-center flex-column">
        <svg
          width="146"
          height="146"
          viewBox="0 0 146 146"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M73 138C108.899 138 138 108.899 138 73C138 37.1015 108.899 8 73 8C37.1015 8 8 37.1015 8 73C8 108.899 37.1015 138 73 138Z"
            fill="#0F854C"
            stroke="#0F854C"
            stroke-width="14.4444"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M94.6663 58.5557L65.7775 87.4446L51.333 73.0001"
            stroke="white"
            stroke-width="14.4444"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div
          style={{
            paddingTop: "32px",
            display: "flex",
            flexDirection: "column",
          }}
          className="fz-30 fw-700 text-center lh-normal mb-0 align-center"
        >
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            Calibration
          </h1>
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            Complete{" "}
          </h1>
        </div>
        {showTakeSeatText && (
          <p
            style={{
              fontSize: "32px",
              lineHeight: "36px",
              fontWeight: 700,
            }}
          >
            Take a seat to begin assessment.
          </p>
        )}
      </div>
    </>
  );
};

export default GaitCalibrationComplete;
